// Phase 1 — synthetic use-case content. 11 personas, four-section structure.
export const USE_CASES = [
  {
    slug: "sdvosb",
    label: "SDVOSB Contractors",
    persona: "Service-Disabled Veteran-Owned Small Business",
    challenge: "DoD and VA opportunities move fast and set-aside competition is dense — manual qualification can't keep up.",
    how_we_help: "Rank set-aside-eligible opportunities by fit, surface incumbent indicators, flag SDVOSB sole-source signals.",
    best_fit_features: ["Prospect Intelligence Report", "Opportunity Qualification", "Competitive Landscape Assessment"],
    next_step: "Take the Product Tour, then run one Opportunity Intelligence Report against a real solicitation.",
  },
  {
    slug: "vosb",
    label: "VOSB Contractors",
    persona: "Veteran-Owned Small Business",
    challenge: "Limited VA set-aside ceiling means every bid has to be a quality bid.",
    how_we_help: "Tighter bid/no-bid scoring with risk + capture-effort calibration.",
    best_fit_features: ["Bid/No-Bid Decision Engine", "Resource Effort Estimate"],
    next_step: "View a Sample Report to see the deliverable.",
  },
  {
    slug: "8a",
    label: "8(a) Contractors",
    persona: "8(a) Business Development Participants",
    challenge: "Nine years to graduate; sole-source ceilings and mentor-protégé strategy require careful pipeline planning.",
    how_we_help: "Capture-window scoring, sole-source candidate detection, mentor-protégé teaming suggestions.",
    best_fit_features: ["Capture Window Score", "Teaming Suggestions", "Prospect Intelligence Report"],
    next_step: "Request a Strategy Call to map your 8(a) ladder.",
  },
  {
    slug: "wosb",
    label: "WOSB Contractors",
    persona: "Women-Owned Small Business",
    challenge: "Identifying which agencies actively use WOSB set-asides vs. nominal ones.",
    how_we_help: "Agency-by-agency WOSB utilization signals + recompete prediction.",
    best_fit_features: ["Agency Buying Patterns", "Recompete Indicators"],
    next_step: "Open the WOSB Strategy lesson in the Academy.",
  },
  {
    slug: "hubzone",
    label: "HUBZone Contractors",
    persona: "HUBZone-Certified Firms",
    challenge: "Geographic eligibility and principal-office rules complicate teaming.",
    how_we_help: "Geo-aware fit scoring + HUBZone-set-aside opportunity surfacing.",
    best_fit_features: ["Geographic Match", "Set-Aside Filter"],
    next_step: "Take the Product Tour focused on Geographic Match.",
  },
  {
    slug: "small-business",
    label: "Small Businesses",
    persona: "All Other Small Business Designations",
    challenge: "Limited capture bandwidth; every bid has to count.",
    how_we_help: "Prioritized prospect list with priority bands (Immediate / This Week / This Month).",
    best_fit_features: ["Priority Bands", "Top 5 Reasons / Top 3 Risks"],
    next_step: "Take the Product Tour.",
  },
  {
    slug: "primes",
    label: "Prime Contractors",
    persona: "Large Primes & Mid-Tiers",
    challenge: "Pipeline grooming across hundreds of opportunities; capture managers drown in spreadsheets.",
    how_we_help: "Bulk intelligence reports + pipeline visibility + competitive landscape per opportunity.",
    best_fit_features: ["Pipeline Visibility", "Competitive Landscape Assessment"],
    next_step: "Request a Strategy Call to discuss enterprise pricing.",
  },
  {
    slug: "subcontractors",
    label: "Subcontractors",
    persona: "Subcontracting-First Firms",
    challenge: "Finding primes who actually win and pay on time.",
    how_we_help: "Prime award-history + past-performance signals on a target prime list.",
    best_fit_features: ["Prime Performance Signals", "Award History"],
    next_step: "View a Sample Report.",
  },
  {
    slug: "consultants",
    label: "Consultants",
    persona: "Capture / Proposal Consultants",
    challenge: "Quickly profiling a new client's pipeline within hours of engagement.",
    how_we_help: "Client-ready intelligence reports for capture briefings.",
    best_fit_features: ["Opportunity Intelligence Report", "Top 5 Reasons / Top 3 Risks"],
    next_step: "Take the Product Tour.",
  },
  {
    slug: "capture-teams",
    label: "Capture Teams",
    persona: "Internal Capture Organizations",
    challenge: "Standardizing bid/no-bid decisions across regions or business units.",
    how_we_help: "Repeatable scoring framework + decision audit trail.",
    best_fit_features: ["Bid/No-Bid Decision Engine", "Decision Rationale"],
    next_step: "Request a Strategy Call.",
  },
  {
    slug: "proposal-teams",
    label: "Proposal Teams",
    persona: "Proposal Managers & Writers",
    challenge: "Decoding Section L / Section M evaluation language under deadline.",
    how_we_help: "Pre-proposal Opportunity Intelligence Report flags eval risks before color reviews.",
    best_fit_features: ["Evaluation Criteria Analysis", "Compliance Risks"],
    next_step: "View a Sample Report.",
  },
];

export const findUseCase = (slug) => USE_CASES.find((u) => u.slug === slug);
